import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import styles from './Hotels.module.scss';
import { Filters } from "@kursk/components/ui/Filters/Filters";
import { hotelsSlice } from "@common/redux/slices/entities.slice";
import { HotelsGrid } from "./HotelsGrid/HotelsGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { HeroBlock } from "@kursk/components/ui/HeroBlock/HeroBlock";
import { picksSlice } from "@common/redux/slices/picks";
import { LdJson } from "@kursk/components/seo/LdJson";
import React from "react";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";
import { themeValue } from "@kursk/themes";

export const Hotels = () => {
  const { total, meta, filters, items } = useSelectSlice(hotelsSlice);
  const { listEvents, listTouristRoutes, listOverviews } = useSelectSlice(recommendationSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);
  const { bannersInCatalogs } = useSelectSlice(picksSlice);

  return (
    <Layout showSubscribePopup={false} page="hotels">
      <SeoMetaTitles
        page="hotels"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, 'гостиницы')}
        meta={meta}
      />
      <HeroBlock banners={bannersInCatalogs} page="hotels"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            page="hotels"
            tags={meta.tags}
            selectedTags={selectedTags}
            title={themeValue({
              astrakhan: 'где разместиться',
              default: 'гостиницы',
            })}
            dashTitle={'Найдено гостиниц'}
            total={total}
          />
        </div>
        <div className={styles.filters}>
          <Filters
            entityType={'hotels'}
            meta={meta}
            filters={filters}
            withPrices
            withLocales
            withPricesOptions={{
              dropDownTitle: 'Цена номера за сутки (₽)'
            }}/>
        </div>
        <div className={styles.items}>
          {items && items.length > 0 && items.map(item => {
            return (
              <LdJson
                key={item._id}
                entity={item}
                type={'hotels'}
              />
            )
          }
          )}
          <HotelsGrid/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="events"
            data={listEvents}
            title={'Рекомендуем посетить'}
            goTo={'/events'}
            goToTitle={'все события'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="touristroutes"
            data={listTouristRoutes}
            title={'Рекомендуем спланировать маршрут'}
            goTo={'/touristroutes'}
            goToTitle={'все маршруты'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="overviews"
            data={listOverviews}
            title={'Рекомендуем почитать'}
            goTo={'/overviews'}
            goToTitle={'все обзоры'}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
